export default __webpack_public_path__ + "static/media/CDS-2023.8be399e5.jpg";